module.exports = __webpack_public_path__ + "img/9W.bbc20027.png";